import React from "react";
import { CHAT_LAYOUT_MAX_WIDTH } from "../constants/chatLayout";

interface ConversationStarter {
  id: string;
  suggestion: string;
}

interface ConversationStartersProps {
  starters: ConversationStarter[];
  onSelect: (suggestion: string) => void;
  isLoading: boolean;
  /** When true, only the starter grid (no duplicate hero heading). */
  hideHero?: boolean;
}

export const ConversationStarters: React.FC<ConversationStartersProps> = ({
  starters,
  onSelect,
  isLoading,
  hideHero = false,
}) => {
  const grid = (
    <div
      className={`mx-auto grid w-full max-w-lg grid-cols-1 gap-2.5 sm:max-w-xl sm:grid-cols-2 sm:gap-3 ${
        hideHero ? "justify-items-stretch text-center" : ""
      }`}
    >
      {starters.map((starter, idx) => (
        <button
          key={starter.id}
          type="button"
          onClick={() => onSelect(starter.suggestion)}
          className={`rounded-lg border border-theme-border bg-theme-surface p-3 transition-all duration-200 animate-fadeIn hover:border-theme-primary/40 hover:bg-theme-background hover:shadow-sm disabled:opacity-50 sm:p-3.5 ${
            hideHero ? "text-center" : "text-left"
          }`}
          disabled={isLoading}
          style={{ animationDelay: `${200 + idx * 50}ms` }}
        >
          <p
            className={`text-sm leading-snug text-theme-fg sm:text-[0.95rem] ${hideHero ? "text-balance text-center" : ""}`}
          >
            {starter.suggestion}
          </p>
        </button>
      ))}
    </div>
  );

  if (hideHero) {
    return (
      <div className="flex w-full animate-fadeIn justify-center text-center">
        {grid}
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col items-center justify-center animate-fadeIn">
      <div
        className="mb-8 animate-fadeIn text-center"
        style={{ animationDelay: "100ms" }}
      >
        <h3 className="mb-2 text-[1.35rem] font-semibold text-theme-fg">
          How can I help you today?
        </h3>
        <p className="mb-6 text-[1.05rem] text-theme-fg-muted">
          Choose a conversation starter or type your own message
        </p>
      </div>
      <div className={`mx-auto w-full ${CHAT_LAYOUT_MAX_WIDTH}`}>{grid}</div>
    </div>
  );
};
